export default __webpack_public_path__ + "files/media/cal.c449b443.png";